






import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class PaymentButton extends Vue {
	@Prop({ default: 'button' }) readonly type!: string
	@Prop({ default: 'button' }) readonly tag!: string
	@Prop({ default: false }) readonly disabled!: boolean
	@Prop({ default: false }) readonly hollow!: boolean
	@Prop({ default: false }) readonly big!: boolean
	@Prop({ default: true }) readonly minWidth!: boolean
	@Prop({ default: false }) readonly fullwidth!: boolean
	@Prop({ default: ' ' }) readonly extraClass!: string
	
	get btnClasses () {

			return [
				`w-full btn relative leading-none transition-all hover:shadow-lg duration-300 whitespace-no-wrap border border-solid inline-flex items-center justify-center text-white shadow-md hover:bg-weshope-light hover:text-white ${this.extraClass}`,
				this.disabled ? 'pointer-events-none bg-opacity-50 border-opacity-50' : '',
				`border-weshope`,
				'py-e8 px-e8',
				'text-18',
				'font-bold',
			]
	}
}
